export default class InvalidDriveLessInsert extends Error {
    constructor() {
        super("This play must be inserted into a drive!");
    }
}
